import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { trackBeginListing } from "@/lib/analytics";
import { operatorFooterLine } from "@/lib/operator";
import SureheldLogo from "@/components/SureheldLogo";

export default function Footer() {
  return (
    <footer className="mt-10 bg-[#0E0E0E] text-white border-t-2 border-[#262626]" data-testid="site-footer">
      <div className="stb-warning-strip" aria-hidden />
      <div className="stb-container py-8 grid gap-8 md:grid-cols-12">
        {/* Brand */}
        <div className="md:col-span-4">
          <Link to="/" className="inline-block">
            <img
              src="/stavbos-logo-wide.png"
              alt="STAVBOŠ"
              className="h-10 w-auto mb-3"
            />
          </Link>
          <p className="text-sm text-[#A3A3A3]">
            Stavební bazar a online inzerce bez omezení a buzerace.
          </p>
        </div>

        {/* Inzerce */}
        <div className="md:col-span-2">
          <h4 className="stb-label mb-3">Inzerce</h4>
          <ul className="text-sm space-y-2">
            <li><Link to="/" className="hover:text-[#FF6B00]">Procházet inzeráty</Link></li>
            <li>
              <Link
                to="/novy-inzerat"
                className="hover:text-[#FF6B00]"
                onClick={() => trackBeginListing({ source: "footer" })}
              >
                Vložit inzerát zdarma
              </Link>
            </li>
            <li><Link to="/jak-to-funguje" className="hover:text-[#FF6B00]">Jak to funguje</Link></li>
          </ul>
        </div>

        {/* Účet */}
        <div className="md:col-span-2">
          <h4 className="stb-label mb-3">Tvoje inzeráty</h4>
          <ul className="text-sm space-y-2">
            <li><Link to="/moje-inzeraty-email" className="hover:text-[#FF6B00]">Najít moje inzeráty</Link></li>
            <li>
              <Link
                to="/novy-inzerat"
                className="hover:text-[#FF6B00]"
                onClick={() => trackBeginListing({ source: "footer_my" })}
              >
                Vložit nový
              </Link>
            </li>
          </ul>
        </div>

        {/* Právní */}
        <div className="md:col-span-2">
          <h4 className="stb-label mb-3">Právní</h4>
          <ul className="text-sm space-y-2">
            <li><Link to="/obchodni-podminky" className="hover:text-[#FF6B00]" data-testid="footer-terms">Obchodní podmínky</Link></li>
            <li><Link to="/gdpr" className="hover:text-[#FF6B00]" data-testid="footer-gdpr">GDPR</Link></li>
            <li><Link to="/kontakt" className="hover:text-[#FF6B00]" data-testid="footer-contact">Kontakt</Link></li>
          </ul>
        </div>

        {/* CraftBolt partner */}
        <div className="md:col-span-2">
          <h4 className="stb-label mb-3">Partneři</h4>
          <div className="space-y-2">
            <a
              href="https://www.craftbolt.cz"
              target="_blank"
              rel="noopener noreferrer"
              className="stb-card block p-3 no-underline group hover:border-[#FF6B00]"
              data-testid="footer-craftbolt-link"
            >
              <img
                src="/craftbolt-logo.svg"
                alt="CraftBolt"
                className="h-8 w-auto transition-transform duration-200 group-hover:scale-105"
                data-testid="footer-craftbolt-logo"
              />
              <p className="stb-mono text-[10px] text-[#A3A3A3] mt-2 leading-tight">
                Najdi řemeslníka
              </p>
              <ExternalLink size={12} className="text-[#FF6B00] mt-2" />
            </a>
            <a
              href="https://www.sureheld.com"
              target="_blank"
              rel="noopener noreferrer"
              className="stb-card block p-3 no-underline group hover:border-[#FF6B00]"
              data-testid="footer-sureheld-link"
              title="Otevřít Sureheld v novém okně"
            >
              <SureheldLogo
                className="transition-transform duration-200 group-hover:scale-105"
                testId="footer-sureheld-logo"
              />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#262626]">
        <div className="stb-container py-4 text-xs text-[#A3A3A3]">
          <span data-testid="footer-legal-line">
            {operatorFooterLine()}
          </span>
        </div>
      </div>
    </footer>
  );
}
